import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { CardAction, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import logoLight from '@/assets/img/logo.svg'
import logoDark from '@/assets/img/logo-white.svg'

type PropsType = {
  description?: string
}

const AuthHeader = ({ description }: PropsType) => {
  const t = useTranslations()

  return (
    <>
      <CardHeader>
        <CardTitle>{t('admin_dashboard')}</CardTitle>
        <CardDescription>{description}</CardDescription>
        <CardAction>
          <Image src={logoLight} alt={t('admin_dashboard')} height={28} className="dark:hidden" />
          <Image src={logoDark} alt={t('admin_dashboard')} height={28} className="hidden dark:block" />
        </CardAction>
      </CardHeader>
      <Separator />
    </>
  )
}

export default AuthHeader
